import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-accounts/create')({
  beforeLoad: () => getTitleContextSlice('Create Account'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
